import { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Spinner } from 'reactstrap';
import { ILeaveCountItem } from '../UserDashboard';

interface ICommonDonutChartProps {
  data: ILeaveCountItem;
  heading: string;
  colors: string[];
}

const CommonDonutChart = ({
  data,
  heading,
  colors,
}: ICommonDonutChartProps) => {
  const [isLoading] = useState(false);

  const chartData = { ...data };
  delete chartData?.total;

  const labels = Object.keys(chartData).map(
    (label) => label.charAt(0).toUpperCase() + label.slice(1),
  );

  const realValues = Object.values(chartData);
  const series = realValues.map((val) => (val === 0 ? 0.1 : val));

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: 'donut',
    },
    labels: labels,
    colors: colors,
    legend: {
      position: 'bottom',
    },
    dataLabels: {
      enabled: true,
      formatter: function (_, opts) {
        return realValues[opts.seriesIndex].toString();
      },
    },
    tooltip: {
      y: {
        formatter: function (_, { seriesIndex }) {
          return realValues[seriesIndex].toString();
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 250,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  return (
    <div className="col-12 col-xl-3 col-lg-4 col-md-6">
      <div className="card check-in h-100 m-0">
        <div className="card-body h-100">
          <div className="card-head">
            <h3 className="card-title">{heading}</h3>
          </div>
          <div>
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: 200 }}
              >
                <Spinner />
              </div>
            ) : (
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                height={200}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonDonutChart;
